import {useSubtitle} from '../../../../../../common/helpers/react/hooks/useSubtitle';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import {useOnce} from '../../../../../../common/helpers/react/hooks/useOnce';
import {SearchType} from '../../../../../../common/model/types/assignees/SearchType';
import AssigneesTable from '../../assignees/AssigneesTable';
import AssigneesSearch from '../../assignees/AssigneesSearch';
import AgentsToolbar from './AgentsToolbar';
import {GroupParticipantType} from '../../../../../../core/rest-client/aat';
import {useLocation, useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';

type AgentsLocationState = {
    keepSearch?: boolean;
};

export default function AgentsPresenter() {
    useSubtitle(tAsString('MANAGE_AGENTS'));

    const location = useLocation();
    const navigate = useNavigate();
    const [keepSearch] = useState(
        () => (location.state as AgentsLocationState | null)?.keepSearch === true
    );

    const controllers = useControllers();
    const groups = controllers.groups;
    const agents = controllers.agents;

    useEffect(() => {
        if (keepSearch) {
            navigate(location.pathname, {
                replace: true,
                state: null
            });
        }
    }, [keepSearch, location.pathname, navigate]);

    useOnce(() => {
        if (keepSearch) {
            return;
        }

        agents.setSearchType(SearchType.AGENT_NAME);
        agents.setSearchPattern('');

        groups.searchForPossibleAssignees({
            searchCriteria: {
                type: GroupParticipantType.AgentName,
                pattern: '*'
            }
        }).andWeAreDone();
    });

    return (
        <>
            <h1>{tAsString('MANAGE_AGENTS')}</h1>
            <AssigneesSearch
                initialSearchType={keepSearch ? undefined : SearchType.AGENT_NAME}
                persistSearchValue={true}
            />
            <AgentsToolbar/>
            <AssigneesTable/>
        </>
    );
}